import { render, staticRenderFns } from "./IntangibleItem.vue?vue&type=template&id=3982ce90&"
import script from "./IntangibleItem.vue?vue&type=script&lang=js&"
export * from "./IntangibleItem.vue?vue&type=script&lang=js&"
import style0 from "./IntangibleItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports